import { render } from "./AsignacionTipsters.vue?vue&type=template&id=f48454a4&scoped=true"
import script from "./AsignacionTipsters.vue?vue&type=script&lang=js"
export * from "./AsignacionTipsters.vue?vue&type=script&lang=js"

import "./AsignacionTipsters.vue?vue&type=style&index=0&id=f48454a4&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f48454a4"]])

export default __exports__